require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-ivette-heres-how-shes-impacting-her-community-after-code-201.json") })
        }
      }, "path---blog-meet-ivette-heres-how-shes-impacting-her-community-after-code-201");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-ivette-heres-how-shes-impacting-her-community-after-code-201!./.cache/json/blog-meet-ivette-heres-how-shes-impacting-her-community-after-code-201.json
// module id = 960
// module chunks = 231608221292675